module.exports = __webpack_public_path__ + "img/fuel-15.796289dc.svg";